import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';

class TableNoData extends React.Component {
    render() {
        return (
            <TableRow>
                <TableCell colSpan={this.props.colSpan}>
                    Unfortunately, no data match these search criteria
                </TableCell>
            </TableRow>
        );
    }
}

TableNoData.propTypes = {
    colSpan: PropTypes.number.isRequired,
};

export default TableNoData;



// WEBPACK FOOTER //
// ./src/components/table/TableNoData.js